import {
    AppBar,
    Box,
    Button,
    Grid,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Search from '@Components/General/Search';
import {
    HelpOutlineRounded,
    MenuRounded,
    NotificationsRounded,
} from '@mui/icons-material';
import { useNavigate, useSearch } from '@tanstack/react-router';

const DesktopHeader = ({
    title,
    quickActions = [],
    titleSuffix,
    searchProps,
}) => {
    const { search: searchValue } = useSearch({});
    const navigate = useNavigate();

    // if (!title) return null;
    return (
        <Grid container my={3} alignItems="center">
            <Grid item xs={4}>
                <Box display="flex" alignItems="baseline" gap={1}>
                    <Typography variant="headlineLarge" minWidth="max-content">
                        {title}
                    </Typography>
                    {titleSuffix && (
                        <Typography variant="bodyLarge" noWrap>
                            / {titleSuffix}
                        </Typography>
                    )}
                </Box>
            </Grid>
            <Grid item xs={4}>
                {searchProps && (
                    <Search
                        key={title + searchValue}
                        {...searchProps}
                        initialValue={searchValue}
                        onSubmit={value =>
                            navigate({
                                search: prev => ({
                                    ...prev,
                                    search: value || undefined,
                                }),
                            })
                        }
                    />
                )}
            </Grid>
            <Grid item xs={4} display="flex" gap={1} justifyContent="flex-end">
                {quickActions.map(({ label, action, ...rest }, index) => (
                    <Button
                        key={index}
                        variant="outlined"
                        onClick={action}
                        {...rest}
                    >
                        {label}
                    </Button>
                ))}
                <Box>
                    <IconButton>
                        <HelpOutlineRounded />
                    </IconButton>
                    <IconButton>
                        <NotificationsRounded />
                    </IconButton>
                </Box>
            </Grid>
        </Grid>
    );
};

const MobileHeader = ({
    title,
    quickActions = [],
    titleSuffix,
    searchProps,
    openNav,
}) => {
    const { search: searchValue } = useSearch({});
    const navigate = useNavigate();

    return (
        <AppBar position="sticky">
            <Box my={2} display="flex" alignItems="center">
                <IconButton onClick={openNav}>
                    <MenuRounded />
                </IconButton>
                {/* <Box display="flex" alignItems="baseline" gap={1}>
                <Typography variant="headlineLarge" minWidth="max-content">
                    {title}
                </Typography>
                {titleSuffix && (
                    <Typography variant="bodyLarge" noWrap>
                        / {titleSuffix}
                    </Typography>
                )}
            </Box> */}
                {searchProps && (
                    <Search
                        key={title + searchValue}
                        {...searchProps}
                        initialValue={searchValue}
                        onSubmit={value =>
                            navigate({
                                search: prev => ({
                                    ...prev,
                                    search: value || undefined,
                                }),
                            })
                        }
                    />
                )}
            </Box>
        </AppBar>
    );
};

const Header = props => {
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up('md'));

    return isSmUp ? <DesktopHeader {...props} /> : <MobileHeader {...props} />;
};

export default Header;
